import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import { useNavigate } from 'react-router-dom';
import './scrapRateList.css';

const ScrapRateList = () => {
    const [scrapRates, setScrapRates] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchScrapRates = async () => {
            try {
                const token = JSON.parse(sessionStorage.getItem('accessToken'));
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/rate/scraprate`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setScrapRates(response.data.scrapRates);
            } catch (error) {
                console.error(error);
            }
        };
        fetchScrapRates();
    }, []);

    const handleDragEnd = async (result) => {
        const { source, destination } = result;

        if (!destination) return;

        const reorderedRates = Array.from(scrapRates);
        const [movedRate] = reorderedRates.splice(source.index, 1);
        reorderedRates.splice(destination.index, 0, movedRate);

        try {
            await axios.put(
                `${process.env.REACT_APP_API_URL}/admin/rate/order`,
                reorderedRates.map((rate, index) => ({
                    _id: rate._id,
                    order: index,
                })),
                {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('accessToken'))}`,
                    }
                }
            );
            setScrapRates(reorderedRates);
        } catch (error) {
            console.error('Error updating scrap rates:', error);
        }
    };

    return (
        <div className="scrap-rate-container">
            <button
                className="add-button"
                onClick={() => navigate('/admin/updateScrapRate')}
            >
                Add Scrap Rates
            </button>
            <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="scrapRatesList">
                    {(provided) => (
                        <div
                            className="scrap-rate-list"
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                        >
                            {scrapRates.map((rate, index) => (
                                <Draggable key={rate._id} draggableId={rate._id} index={index}>
                                    {(provided) => (
                                        <div
                                            className="scrap-rate-card"
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                        >
                                            <img
                                                src={`${process.env.REACT_APP_API_URL}${rate.iconPath}`}
                                                alt={rate.scrapName}
                                                className="scrap-rate-icon"
                                            />
                                            <div className="scrap-rate-details">
                                                <h3>{rate.scrapName}</h3>
                                                <p>{rate.pricePerKg}</p>
                                            </div>
                                            <button
                                                className="edit-button"
                                                onClick={() =>
                                                    navigate('/admin/updateScrapRate', {
                                                        state: { isEditing: true, scrapRate: rate },
                                                    })
                                                }
                                            >
                                                Edit
                                            </button>
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        </div>
    );
};

export default ScrapRateList;
